import {Injectable} from '@angular/core';
import {Http, Response, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Rx';

import {User} from './user.model';

@Injectable()
export class UserService {
    private resourceUrl = 'api/users';
    private resourceAuthoritiesUrl = 'api/authorities';
    private resourceLdapUrl = 'api/ldapusers';

    constructor(private http: Http) { }

    create(user: User): Observable<Response> {
        return this.http.post(this.resourceUrl, user);
    }

    update(user: User): Observable<Response> {
        return this.http.put(this.resourceUrl, user);
    }

    find(login: string): Observable<User> {
        return this.http.get(`${this.resourceUrl}/${login}`).map((res: Response) => res.json());
    }

    findById(userId: Number): Observable<User> {
        return this.http.get(`${this.resourceUrl}/byid/${userId}`).map((res: Response) => res.json());
    }

    query(req?: any): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();
        if (req) {
            params.set('page', req.page);
            params.set('size', req.size);
            params.set('userENS', req.userENS);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
        }

        let options = {
            search: params
        };

        return this.http.get(this.resourceUrl, options);
    }

    queryLDAP(req?: any): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();
        if (req) {
            params.set('search', req.search);
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
        }
        let options = {
            search: params
        };
        return this.http.get(this.resourceLdapUrl, options);
    }

    delete(login: string): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${login}`);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/user/user.service.ts